import PropTypes from 'prop-types'
import React from 'react'

import DropdownRowBase from './DropdownRowBase'
import * as Links from '../../../../shared_components/Links'

import {HelpIcon} from '../../../assets/UserMenuIcons'


const HelpRow = props => {
  const HelpLink = props.currentUser.firm_user ? Links.ProHelp : Links.Help

  return (
    <DropdownRowBase>
      <HelpLink>
        <HelpIcon aria-hidden='true' className='dropdown-icon' focusable='false' />
        Help
      </HelpLink>
    </DropdownRowBase>
  )
}

HelpRow.propTypes = {
  currentUser: PropTypes.shape({
    firm_user: PropTypes.bool
  })
}

export default HelpRow
